<template>
    <div>
        <Title>用印审批</Title>
        <div class="panel">
            <div class="label">流水号</div>
            <div class="value1">{{ extra.serialNo }}</div>
            <div class="label">图纸数量</div>
            <div class="value2">{{ extra.drawingCount }}</div>
            <div class="label">用印用途</div>
            <div class="value1">{{ extra.drawingPurpose }}</div>
            <div class="label">出图章</div>
            <div class="value2">{{ stampDesign1 }}</div>
            <div class="label">出图章2</div>
            <div class="value1">{{ stampDesign2 }}</div>
            <div class="label">注册章</div>
            <div class="value2">{{ stampRegister1 }}</div>
            <div class="label">注册章2</div>
            <div class="value1">{{ stampRegister2 }}</div>
            <div class="label">出图日期</div>
            <div class="value2">{{ formatDate(extra.drawingDate) }}</div>
        </div>

        <Title>工程信息</Title>
        <div class="panel">
            <div class="label">工程名称</div>
            <div class="value1">{{ phase.name }}</div>
            <div class="label">工程编号</div>
            <div class="value2">{{ phase.code }}</div>
            <div class="label">阶段名称</div>
            <div class="value1">{{ phase.phaseName }}</div>
            <div class="label">主办部门</div>
            <div class="value2">{{ phase.mainDeptName }}</div>
            <div class="label">项目负责人</div>
            <div class="value1">{{ phase.planPrjLeaderName }}</div>
            <div class="label">备注</div>
            <div class="value2">{{ extra.remark }}</div>
        </div>

        <Title>图纸列表</Title>
        <div class="table-wrap">
            <table>
                <thead>
                <tr>
                    <th>流水号</th>
                    <th>版本号</th>
                    <th>图名</th>
                    <th>分图号</th>
                    <th>页码</th>
                    <th>总页数</th>
                    <th>纸张尺寸</th>
                    <th>制图人</th>
                    <th>项目负责</th>
                    <th>审定</th>
                    <th>审核</th>
                    <th>专业负责</th>
                    <th>校核</th>
                    <th>设计</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in drawingList" :key="item.id">
                    <td>{{ item.serialNo }}</td>
                    <td>{{ item.versionNo }}</td>
                    <td><a href="javascript:void(0)" @click="handlePreview(item)">{{ item.name || '第' + item.pageNumber + '页' }}</a></td>
                    <td>{{ item.subDrawingNo }}</td>
                    <td>{{ item.pageNumber }}</td>
                    <td>{{ item.pageCount }}</td>
                    <td>{{ item.pageSize }}</td>
                    <td>{{ item.drawerName }}</td>
                    <td>{{ item.xmfz }}</td>
                    <td>{{ item.sd }}</td>
                    <td>{{ item.sh }}</td>
                    <td>{{ item.zyfz }}</td>
                    <td>{{ item.jh }}</td>
                    <td>{{ item.sj }}</td>
                </tr>
                </tbody>
            </table>
        </div>

        <Title>附件</Title>
        <div class="panel">
            <div class="label">附件信息</div>
            <div  class="value3">
                <div v-for="(att, i) in attachmentList" :key="i">
                    <div>原文件：<span style="margin-right: 30px;color: #0e7bc6;">{{ att.name }}</span>&nbsp;&nbsp;&nbsp;最终版文件：<span style="color: #0e7bc6;">{{ att.finalName || '--' }}</span></div>
                </div>
            </div>
        </div>

        <Title>用印审批</Title>
        <div class="panel">
            <template v-if="pairedUsers.length">
                <template v-for="(pair, index) in pairedUsers">
                    <div :key="`l-${index}`" class="label">{{ typeLabel(pair.first.type) }}</div>
                    <div :key="`v1-${index}`" class="value1">{{ pair.first.username || '--' }}</div>

                    <div :key="`l2-${index}`" class="label" v-if="pair.second">
                        {{ typeLabel(pair.second.type) }}
                    </div>
                    <div :key="`v2-${index}`" class="value2" v-if="pair.second">
                        {{ pair.second.username || '--' }}
                    </div>
                </template>
            </template>
            <div v-if="!pairedUsers.length" class="value3">--</div>
        </div>
        <Padding />
    </div>
</template>

<script>
import { mapState } from "vuex";
import Title from "../Title";
const typeMap = {
    cosys_stamp_fadingdaibiaoren: "法定代表人",
    cosys_stamp_jishufuze: "技术负责",
    cosys_stamp_pizhun: "批准",
    cosys_stamp_shejifuze: "设计负责",
    cosys_stamp_shejifuze2: "设计负责2",
    cosys_stamp_zhuanyefuze: "专业负责",
    cosys_stamp_zhuanyefuze2: "专业负责2",
    cosys_stamp_xiaohe: "校核",
    cosys_stamp_shenhe: "审核",
    cosys_stamp_shending: "审定",
    cosys_stamp_sheji: "设计",
    cosys_stamp_sheji2: "设计2",
    cosys_stamp_zhitu: "制图",
    cosys_stamp_zixunyuan: "咨询员",
    cosys_stamp_zhuanyehuijian1: "专业会签1",
    cosys_stamp_zhuanyehuijian2: "专业会签2",
    cosys_stamp_zhuanyehuijian3: "专业会签3",
    cosys_stamp_zhuanyehuijian4: "专业会签4",
    cosys_stamp_zhuanyehuijian5: "专业会签5",
    cosys_stamp_zixunyuan2: "咨询员2",
    cosys_stamp_zixunyuan3: "咨询员3",
    cosys_stamp_shending2: "审定2",
    cosys_stamp_shending3: "审定3",
    cosys_stamp_shending4: "审定4",
    cosys_stamp_xiaohe2: "校核2",
    cosys_stamp_xiaohe3: "校核3",
    cosys_stamp_xiaohe4: "校核4",
    cosys_stamp_xiaohe5: "校核5",
    cosys_stamp_xiaohe6: "校核6",
    cosys_stamp_xiaohe7: "校核7",
    cosys_stamp_xiaohe8: "校核8",
    cosys_stamp_shenhe2: "审核2",
    cosys_stamp_shenhe3: "审核3",
    cosys_stamp_shenhe4: "审核4",
    cosys_stamp_shenhe5: "审核5",
    cosys_stamp_shenhe6: "审核6",
    cosys_stamp_shenhe7: "审核7",
    cosys_stamp_shenhe8: "审核8",
    cosys_stamp_zhuanyefuze3: "专业负责3",
    cosys_stamp_zhuanyefuze4: "专业负责4",
    cosys_stamp_zhuanyefuze5: "专业负责5",
    cosys_stamp_zhuanyefuze6: "专业负责6",
    cosys_stamp_zhuanyefuze7: "专业负责7",
    cosys_stamp_zhuanyefuze8: "专业负责8",
    cosys_stamp_xmfz: "项目负责",
    cosys_stamp_xmfz2: "项目负责2",
};
export default {
    components: {
        Title,
    },
    data() {
        return {};
    },
    created() {},
    computed: {
        ...mapState("approval", ["detail"]),
        extra() {
            return this.detail.extra ? this.detail.extra : {};
        },
        stampConfigList() {
            try {
                const json = this.extra.stampConfigJson;
                return json ? JSON.parse(json) : [];
            } catch {
                return [];
            }
        },
        stampDesign1() {
            const items = this.stampConfigList.filter(i => i.stampType === 'design');
            if (items.length > 0) {
                return items[0].major || '--';
            }
            return '--';
        },
        stampDesign2() {
            const items = this.stampConfigList.filter(i => i.stampType === 'design');
            if (items.length > 1) {
                return items[1].major || '--';
            }
            return '--';
        },
        stampRegister1() {
            const items = this.stampConfigList.filter(i => i.stampType === 'register');
            if (items.length > 0) {
                return items[0].userName ? `${items[0].major}-${items[0].userName}` : items[0].major || '--';
            }
            return '--';
        },
        stampRegister2() {
            const items = this.stampConfigList.filter(i => i.stampType === 'register');
            if (items.length > 1) {
                return items[1].userName ? `${items[1].major}-${items[1].userName}` : items[1].major || '--';
            }
            return '--';
        },
        phase() {
            return this.extra.phase || {};
        },
        drawingList() {
            return this.extra.subList || [];
        },
        attachmentList() {
            try {
                const json = this.extra.attachment;
                return json ? JSON.parse(json) : [];
            } catch {
                return [];
            }
        },
        users() {
            if (this.extra.userJson) {
                try {
                    return JSON.parse(this.extra.userJson);
                } catch {
                    return [];
                }
            }
            return this.extra.userList || [];
        },
        pairedUsers() {
            const pairs = [];
            for (let i = 0; i < this.users.length; i += 2) {
                pairs.push({
                    first: this.users[i],
                    second: this.users[i + 1] || null,
                });
            }
            return pairs;
        },
    },
    methods: {
        typeLabel(type) {
            return typeMap[type] || type;
        },
        formatDate(timestamp) {
            if (!timestamp) return '--';
            const d = new Date(Number(timestamp));
            const y = d.getFullYear();
            const m = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${y}-${m}-${day}`;
        },
        handlePreview(item) {
            const list = this.drawingList.map(d => ({
                previewAttachment: d.previewAttachment,
                attachment: d.attachment,
                name: d.name || '',
                pageNumber: d.pageNumber,
            }));
            const routeUrl = this.$router.resolve({
                path: '/pdf-preview-list',
                query: {
                    previewAttachment: item.previewAttachment || '',
                    list: JSON.stringify(list),
                },
            }).href;
            window.open(routeUrl, '_blank');
        },
    },
};
</script>

<style lang="less" scoped>
.panel {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    border-top: 1px solid #e8e8e8;

    & > div {
        padding: 8px;
        border-bottom: 1px solid #e8e8e8;
    }

    .label {
        background-color: #fafafa;
        border-right: 1px solid #e8e8e8;
        border-left: 1px solid #e8e8e8;
    }

    .value1 {
        grid-column-start: 2;
        grid-column-end: 4;
    }

    .value2 {
        grid-column-start: 5;
        grid-column-end: 7;
        border-right: 1px solid #e8e8e8;
    }

    .value3 {
        grid-column-start: 2;
        grid-column-end: 7;
        border-right: 1px solid #e8e8e8;
    }
}

.table-wrap {
    overflow: auto;
    max-height: 400px;

    table {
        width: 100%;
        border-collapse: collapse;
        font-size: 13px;

        th, td {
            border: 1px solid #e8e8e8;
            padding: 6px 8px;
            text-align: center;
        }

        th {
            position: sticky;
            top: 0;
            z-index: 1;
            background-color: #fafafa;
            font-weight: 600;
        }

        tbody tr:hover {
            background-color: #f5f5f5;
        }
    }
}
</style>
